import Vue from 'vue'

export default new Vue({
  data() {
    return {
      viewport: {
        width: 100,
        height: 100,
      },
    }
  },
  computed: {
    isMobile() {
      return this.viewport.width < 530
    },
    isTablet() {
      return this.viewport.width >= 530 && this.viewport.width < 950
    },
    isPortableDevice() {
      return this.isMobile || this.isTablet
    },
    isSmallDesktop() {
      return this.viewport.width >= 950 && this.viewport.width < 1130
    },
    isLargeDesktop() {
      return this.viewport.width >= 1130
    },
    current() {
      if (this.isMobile)
        return 'mobile'
      if (this.isTablet)
        return 'tablet'
      if (this.isSmallDesktop)
        return 'small_desktop'
      if (this.isLargeDesktop)
        return 'large_desktop'
    },
  },
  created() {
    this.getViewport()
    window.addEventListener('resize', () => {
      this.getViewport()
    })
  },
  methods: {
    getViewport() {
      let win = window
      let prefix = 'inner'

      if (!('innerWidth' in window)) {
        prefix = 'client'
        win = document.documentElement || document.body
      }

      this.viewport = {
        width: win[`${prefix}Width`],
        height: win[`${prefix}Height`],
      }
    },
  },
})



// WEBPACK FOOTER //
// ./client/src/media_query.js